import { render, staticRenderFns } from "./selOrderItem.vue?vue&type=template&id=42d5be82&scoped=true"
import script from "./selOrderItem.vue?vue&type=script&lang=js"
export * from "./selOrderItem.vue?vue&type=script&lang=js"
import style0 from "./selOrderItem.vue?vue&type=style&index=0&id=42d5be82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d5be82",
  null
  
)

export default component.exports